import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropDownModule } from '@shared/core/components/dropDown';
import { IconModule } from '@shared/core/components/icon';
import { ImagePreloadDirectiveSharedModule } from '@shared/core/directives/imagePreload';
import { HighlightMatchPipeModule } from '@shared/core/pipes/highlightMatch';

import { PlacesSuggestionComponent } from './places-suggestion.shared.component';

@NgModule({
    declarations: [
        PlacesSuggestionComponent
    ],
    imports: [
        CommonModule,
        DropDownModule,
        IconModule,
        ImagePreloadDirectiveSharedModule,
        HighlightMatchPipeModule,
    ],
    exports: [
        PlacesSuggestionComponent
    ]
})
export class PlacesSuggestionModule { }
